import React from 'react';

const DeleteAccount = () => {
  const supportEmail = "info@mcnallyelectrical.co.uk";
  const mailtoHref = `mailto:${supportEmail}?subject=Delete%20Account%20Request&body=Hello%20McNally%20EV%20Team,%0D%0A%0D%0AI%20would%20like%20to%20request%20the%20deletion%20of%20my%20account%20and%20all%20associated%20data.%0D%0A%0D%0ARegistered%20email%3A%20%5Byour%20email%5D%0D%0AFull%20name%3A%20%5Byour%20name%5D%0D%0A%0D%0AThank%20you.`;

  return (
    <div className="min-h-screen bg-white text-[#10303A] flex-1   px-6 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <h1 className="text-4xl font-bold text-center text-[#5298A8] mb-8">
          Delete Account — McNally EV
        </h1>
        <p className="text-base leading-relaxed mb-6">
          You can permanently delete your McNally EV account and request removal of your personal data.
          Choose one of the options below.
        </p>

        {/* Option 1: In-App Deletion */}
        <section className="border border-[#E6EDF0] rounded-2xl p-5 mb-6">
          <h2 className="text-2xl font-semibold text-[#5298A8] mb-2">Option 1: Delete directly in the app</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>Open the <strong>McNally EV</strong> app and sign in.</li>
            <li>Go to <strong>Settings &gt; Account</strong>.</li>
            <li>Select <strong>Delete Account</strong> and follow the on-screen confirmation steps.</li>
          </ol>
          <p className="mt-3 text-sm opacity-80">
            Once confirmed, your account is scheduled for deletion and you’ll be signed out.
          </p>
        </section>

        {/* Option 2: Email Request */}
        <section className="border border-[#E6EDF0] rounded-2xl p-5 mb-6">
          <h2 className="text-2xl font-semibold text-[#5298A8] mb-2">Option 2: Request via email</h2>
          <p className="mb-4">
            Send an email with the subject <em>“Delete Account Request”</em> to:
          </p>
          <a
            href={mailtoHref}
            className="inline-block bg-[#5298A8] text-white font-medium px-5 py-3 rounded-xl shadow hover:opacity-90 transition"
          >
            Email {supportEmail}
          </a>
          <p className="mt-4 text-sm">
            Please include your <strong>registered email</strong> and <strong>full name</strong> to verify your identity.
          </p>
        </section>

        {/* What gets deleted */}
        <section className="border border-[#E6EDF0] rounded-2xl p-5 mb-6">
          <h2 className="text-2xl font-semibold text-[#5298A8] mb-2">What will be deleted</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Account profile data (name, email, profile photo, phone number).</li>
            <li>User-submitted photos and content associated with your account.</li>
            <li>App usage records linked to your identity (used for analytics).</li>
          </ul>
          <p className="mt-3 text-sm opacity-80">
            We do not store payment methods. Some minimal records may be retained where legally required (e.g., security logs),
            but they will no longer be associated with your identity.
          </p>
        </section>

        {/* Processing */}
        <section className="border border-[#E6EDF0] rounded-2xl p-5 mb-6">
          <h2 className="text-2xl font-semibold text-[#5298A8] mb-2">Processing time</h2>
          <p>
            We aim to process deletion requests as quickly as possible and will notify you once completed.
          </p>
        </section>

        {/* Help */}
        <section className="border border-[#E6EDF0] rounded-2xl p-5">
          <h2 className="text-2xl font-semibold text-[#5298A8] mb-2">Need help?</h2>
          <p>
            If you have any questions, contact us at{" "}
            <a href={`mailto:${supportEmail}`} className="underline text-[#5298A8]">
              {supportEmail}
            </a>.
          </p>
        </section>

        {/* Footer / Last updated */}
        <p className="text-sm text-right text-[#5298A8] mt-10 italic">
          Last updated: 28 August 2025
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;